export default __webpack_public_path__ + "8eb2e7aa69454812bcb5ddd53f25e486.png";